import React from 'react';
import BookButton from '../Shared/BookButton';
import experts1 from '../../img/expert-1.png'
import experts2 from '../../img/expert-2.png'
import experts3 from '../../img/expert-3.png'

const WhyUs = () => {
    return (
        <div className='px-4 md:px-12 py-10 md:py-20'>
            <div className='md:flex md:flex-row-reverse'>
                <div className='flex-1 mb-12 md:mb-0'>
                    <h1 className='text-blue-400 text-4xl text-center font-semibold mb-6 mt-6'>Why choose Career Hikers?</h1>
                    <p className='ml-4 text-justify font-semibold text-sm'>With thousands of students using Career Hikers to decide their future objectives by using ABHAY program.</p>
                    <div className='flex justify-center'>
                        <BookButton name='Take a Trial Session' />
                    </div>
                </div>
                <div className='flex-1 md:mr-10' >
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 mb-6'>
                        <div className='bg-white shadow-xl rounded-2xl py-2 px-4 '>
                            <img src={experts3} alt="" className='w-24 mx-auto' />
                            <p className='font-semibold text-2xl mt-4 mb-1 text-center'>35000+</p>
                            <p className='text-center mb-2'>Students Impacted</p>
                        </div>
                        <div className='bg-white shadow-xl rounded-2xl py-2 px-4 '>
                            <img src={experts2} alt="" className='w-24 mx-auto' />
                            <p className='font-semibold text-2xl mt-4 mb-1 text-center'>3000+</p>
                            <p className='text-center mb-2'>Sessions Daily</p>
                        </div>
                    </div>
                    <div className='bg-white shadow-xl rounded-2xl py-2 px-4 md:mb-0 mb-12 md:w-64 md:mx-auto'>
                        <img src={experts1} alt="" className='w-24 mx-auto' />
                        <p className='font-semibold text-2xl mt-4 mb-1 text-center'>1100+</p>
                        <p className='text-center mb-2'>Mentors</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyUs;